import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./RegisterAmazonAdvertising.css";

class RegisterAmazonAdvertising extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      accountName: "",
      isSubmitting: false
    };
  }

  handleInputChange = (e) => {
    this.setState({
      accountName: e.target.value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    
    const { accountName } = this.state;
    
    if (!accountName.trim()) {
      alert("Please enter an account name");
      return;
    }

    this.setState({ isSubmitting: true });

    // Store account name in localStorage
    localStorage.setItem('accName', accountName.trim());

    // Redirect to Amazon authorization URL
    const amazonAuthUrl = "https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.8b99dff3ed634b50ad5d039400740b32&scope=advertising::campaign_management&response_type=code&redirect_uri=https://visualcogs.com/advertisingamazon";
    
    // Show redirecting modal
    const redirectingModal = document.getElementById('redirecting-modal');
    if (redirectingModal) {
      redirectingModal.style.display = 'block';
    }

    // Small delay to show the redirecting message
    setTimeout(() => {
      window.location.href = amazonAuthUrl;
    }, 1000);
  };

  navigateToHome = () => {
    this.props.history.push("/");
  };

  render() {
    const { accountName, isSubmitting } = this.state;

    return (
      <div className="register-amazon-page">
        <Helmet>
          <title>Visual COGS | Register Amazon Advertising</title>
          <meta
            name="description"
            content="Register your Amazon Advertising account with Visual COGS to begin creating Sale Voyant reports"
          />
        </Helmet>
        <div className="register-amazon-container">
          <div className="register-amazon-wrapper">
            <div className="register-amazon-content">
              <div className="register-amazon-box">
                <div className="register-amazon-header">
                  <div className="register-amazon-logo">
                    <img 
                      src="/vc-favicon.svg" 
                      alt="Visual COGS" 
                      className="register-logo-img"
                    />
                  </div>
                  <div className="register-amazon-title">
                    Amazon Advertising Integration
                  </div>
                  <div className="register-amazon-subtitle">
                    Enter your account name and begin authorization by clicking the button below.
                  </div>
                  <div className="register-amazon-description">
                    You will be taken to Amazon's authorization page. Once authorized, we will begin creating your Sale Voyant reports.
                  </div>
                </div>

                <form onSubmit={this.handleSubmit} className="register-amazon-form">
                  <div className="register-form-group">
                    <label htmlFor="accountName" className="register-form-label">
                      Account Name
                    </label>
                    <input
                      type="text"
                      id="accountName"
                      name="accountName"
                      value={accountName}
                      onChange={this.handleInputChange}
                      placeholder="Enter your account name"
                      className="register-form-input"
                      required
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="register-form-actions">
                    <button
                      type="submit"
                      className="register-submit-btn"
                      disabled={isSubmitting || !accountName.trim()}
                    >
                      {isSubmitting ? "Redirecting..." : "Begin Authorization"}
                    </button>
                  </div>
                </form>

                <div className="register-home-action">
                  <button
                    type="button"
                    className="register-home-btn"
                    onClick={this.navigateToHome}
                    disabled={isSubmitting}
                  >
                    Go to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(RegisterAmazonAdvertising);
